import React from 'react';

import {
	Wrapper,
	Input,
	Bar,
	StyledRadiobuttonUncheckedIcon,
	StyledRadiobuttonCheckedIcon,
} from './styles';

export const Radio = ({ children, className, center, ...props }) => (
	<Wrapper className={className}>
		<Input type="radio" {...props} />
		<Bar {...props} rcenter={center}>
			<StyledRadiobuttonCheckedIcon />
			<StyledRadiobuttonUncheckedIcon />
			{children}
		</Bar>
	</Wrapper>
);
